import {Injectable} from '@angular/core';
import {HttpClient, HttpRequest, HttpEvent, HttpHeaders} from '@angular/common/http';
import {Constants} from '../constants/constants';
import {Observable} from 'rxjs';
import {CrudService} from '../crud/crud.service';
import {Spring} from '../spring/spring';

const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private http: HttpClient, private constants: Constants, private crud: CrudService,
              private spring: Spring) {
  }

  // Metodo que envia los archivos al endpoint /upload
  upload(file: File, tablaAdjuntos: string, rutaSFTP: string, adjunto: any): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('files', file);
    const req = new HttpRequest('POST', `${this.constants.API_REST}upload/${tablaAdjuntos}&${rutaSFTP}&${adjunto.idtipadj}&${adjunto.id}&${adjunto.comentarios}&${adjunto.fecha === '' ? '2000-01-01' : adjunto.fecha}`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  // Adjuntos
  getAdjuntos(tabla: string, id: number) {
    return this.crud.get(`${this.spring.PSADJUNT_GET_LIST}${tabla}/${id}`)
  }

  // Metodo para borrar los archivos
  deleteFile(filename: string) {
    return this.http.get(`${this.constants.API_REST}delete/${filename}`);
  }


}
